import React from "react";
import { faAppStore, faGooglePlay } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import AppAnalyticsChart from "./AppAnalyticsChart";

import "./AnalyticsSection.scss";

export const AnalyticsSection = ({
							  activePlatform,
							  setActivePlatform,
							  selectedApp,
							  appListData,
							  handleAppSelection,
							  analyticsData,
						  }) => {
	return (
		<div className="analytics-section">
			<div className="analytics-section__header">
				<div className="analytics-section__title">Apps Analytics</div>
				<div className="platform-buttons">
					<button
						className={`platform-button ${activePlatform === "playStore" ? "platform-button--active" : ""}`}
						onClick={() => setActivePlatform("playStore")}
					>
						<FontAwesomeIcon icon={faGooglePlay} size="lg" />
						Play Store
					</button>
					<button
						className={`platform-button ${activePlatform === "appleStore" ? "platform-button--active" : ""}`}
						onClick={() => setActivePlatform("appleStore")}
					>
						<FontAwesomeIcon icon={faAppStore} size="lg" />
						Apple Store
					</button>
				</div>
			</div>
			<select className="select-app-dropdown" value={selectedApp} onChange={handleAppSelection}>
				<option value="">Select App</option>
				{appListData?.map((app) => (
					<option key={app.name} value={app.name}>
						{app.name}
					</option>
				))}
			</select>

			<div className="chart-container">
				<AppAnalyticsChart analyticsData={analyticsData} />
			</div>
		</div>
	);
};
